import React from "react";

/**
 * digicampusbd's sidebar_item.icon_class column holds a mix of Bootstrap
 * Icons ("bi bi-...") and Font Awesome ("fas fa-...") class names — neither
 * icon font is loaded in this app (no old-JS-stack dependency), so those
 * classes previously rendered as empty spans. This maps each real icon_class
 * value (confirmed live against `sidebar_item`) to a small inline SVG in the
 * same thin line-icon style as the reference design, so every top-level
 * section still gets a distinct icon without pulling in an icon font.
 * Falls back to a plain dot for anything unrecognized rather than blank.
 */
const ICONS = {
  "bi bi-speedometer": (
    <>
      <rect x="3" y="3" width="7" height="7" rx="1.5" />
      <rect x="14" y="3" width="7" height="7" rx="1.5" />
      <rect x="3" y="14" width="7" height="7" rx="1.5" />
      <rect x="14" y="14" width="7" height="7" rx="1.5" />
    </>
  ),
  "bi bi-people-fill": (
    <>
      <circle cx="9" cy="7" r="3.2" />
      <path d="M3 20c0-3.5 2.7-6 6-6s6 2.5 6 6" />
      <circle cx="17" cy="8" r="2.4" />
      <path d="M15.5 20c.2-2.8 1.6-4.8 3.5-5.6" />
    </>
  ),
  "fas fa-user-tie": (
    <>
      <circle cx="12" cy="7" r="3.2" />
      <path d="M6 21c0-3.8 2.7-6.5 6-6.5s6 2.7 6 6.5" />
      <path d="M12 14.5l-1.4 3 1.4 2.5 1.4-2.5-1.4-3z" />
    </>
  ),
  "fas fa-donate": (
    <>
      <ellipse cx="8" cy="7" rx="5" ry="2.5" />
      <path d="M3 7v4c0 1.4 2.2 2.5 5 2.5s5-1.1 5-2.5V7" />
      <path d="M3 11v4c0 1.4 2.2 2.5 5 2.5s5-1.1 5-2.5v-4" />
      <circle cx="17.5" cy="15.5" r="4" />
      <path d="M17.5 13.2v4.6M16 15.5h3" />
    </>
  ),
  "fas fa-file-invoice-dollar": (
    <>
      <path d="M6 3h9l4 4v14a1 1 0 01-1 1H6a1 1 0 01-1-1V4a1 1 0 011-1z" />
      <path d="M15 3v4h4" />
      <path d="M9 17v-6M12 17v-3M15 17v-8" />
    </>
  ),
  "bi bi-pencil-square": (
    <>
      <rect x="3" y="4" width="18" height="16" rx="2" />
      <path d="M7 12l3 3 7-7" />
    </>
  ),
  "fas fa-file": (
    <>
      <path d="M6 3h8l4 4v14a1 1 0 01-1 1H6a1 1 0 01-1-1V4a1 1 0 011-1z" />
      <path d="M14 3v4h4" />
    </>
  ),
  "fas fa-receipt": (
    <>
      <path d="M6 3h12v18l-2.5-1.5L13 21l-2.5-1.5L8 21l-2-1.5V3z" />
      <path d="M9 8h6M9 12h6M9 16h4" />
    </>
  ),
  "fas fa-file-signature": (
    <>
      <path d="M6 3h8l4 4v14a1 1 0 01-1 1H6a1 1 0 01-1-1V4a1 1 0 011-1z" />
      <path d="M14 3v4h4" />
      <path d="M8 16c1-1.5 2-1.5 3 0s2 1.5 3 0" />
    </>
  ),
  "fas fa-envelope-square": (
    <>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M3.5 6l8.5 7 8.5-7" />
    </>
  ),
  "bi bi-wrench-adjustable": (
    <>
      <path d="M14.7 6.3a4 4 0 10-5.4 5.4L4 17l3 3 5.3-5.3a4 4 0 005.4-5.4l-2.6 2.6-2-2 2.6-2.6z" />
    </>
  ),
};

const FALLBACK = <circle cx="12" cy="12" r="3" />;

export default function SidebarIcon({ iconClass, className }) {
  const path = ICONS[(iconClass || "").trim()] || FALLBACK;
  return (
    <svg
      className={`sidebar-icon ${className || ""}`}
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {path}
    </svg>
  );
}
